import { AdapterConfigForm } from "../../components/AdapterConfigForms";
import { TestConnectionButton } from "../../components/TestConnectionButton";
import styles from './export-composer.module.css';

// ═══════════════════════════════════════════════════════════════
// AdapterPanel — wraps AdapterConfigForm + TestConnectionButton
// ═══════════════════════════════════════════════════════════════

interface Props {
  adapterType: string;
  config: Record<string, unknown>;
  onChange: (config: Record<string, unknown>) => void;
  jobTypeId: string;
  destinationId: string;
}

export function AdapterPanel({
  adapterType,
  config,
  onChange,
  jobTypeId,
  destinationId: _destinationId, // accepted for API compatibility; form-config always tests draft
}: Props) {
  // R-54 / WU-3.5: form-config destinations live in the draft JSON until
  // publish, so there is no DB row for the `/test` route to look up. Pass
  // `"draft"` as the id and forward the in-memory config + adapterType —
  // the route uses the body when the id is `"draft"` and the row
  // otherwise.
  return (
    <div className={styles.adapterPanel}>
      <AdapterConfigForm adapterType={adapterType} config={config} onChange={onChange} />
      <TestConnectionButton
        jobTypeId={jobTypeId}
        destinationId="draft"
        draftAdapterType={adapterType}
        draftConfig={config}
      />
    </div>
  );
}
